import { getCurrentLanguage } from './i18n';

export const getLocalizedPath = (path: string): string => {
  const currentLocale = getCurrentLanguage();
  
  // Map paths to their localized versions
  const localizedPaths: { [key: string]: { [locale: string]: string } } = {
    '/': {
      'lv': '/lv/',
      'en': '/en/', 
      'ru': '/ru/'
    },
    '/contact': {
      'lv': '/lv/kontakti',
      'en': '/en/contact', 
      'ru': '/ru/kontakty'
    },
    '/loan-types': {
      'lv': '/lv/kreditu-veidi',
      'en': '/en/loan-types',
      'ru': '/ru/vidy-kreditov'
    },
    '/add-bank-account': {
      'lv': '/lv/pievienot-bankas-kontu',
      'en': '/en/add-bank-account',
      'ru': '/ru/dobavit-bankovskiy-schet'
    },
    // Individual loan type pages
    '/hipotekarais-kredits': {
      'lv': '/lv/hipotekarais-kredits',
      'en': '/en/mortgage-loan',
      'ru': '/ru/ipotechniy-kredit'
    },
    '/biznesa-attistibai': {
      'lv': '/lv/biznesa-attistibai',
      'en': '/en/business-development',
      'ru': '/ru/razvitie-biznesa'
    },
    '/eku-buvniecibai': {
      'lv': '/lv/eku-buvniecibai',
      'en': '/en/construction-loan',
      'ru': '/ru/stroitelstvo-zdaniy'
    },
    '/zemniekiem': {
      'lv': '/lv/zemniekiem',
      'en': '/en/farmers',
      'ru': '/ru/fermeryi'
    },
    '/kreditu-apvienosana': {
      'lv': '/lv/kreditu-apvienosana',
      'en': '/en/loan-consolidation',
      'ru': '/ru/obyedinenie-kreditov'
    },
    '/pilna-servisa-auto-lizings': {
      'lv': '/lv/pilna-servisa-auto-lizings',
      'en': '/en/full-service-auto-leasing',
      'ru': '/ru/polnyy-servis-avto-lizing'
    }
  };

  // If we have a localized version, use it
  if (localizedPaths[path] && localizedPaths[path][currentLocale]) {
    return localizedPaths[path][currentLocale];
  }

  // Default fallback
  if (currentLocale !== 'lv') {
    return `/${currentLocale}${path}`;
  }
  
  return path;
};

const localizedSlugGroups: Array<Record<string, string>> = [
  {
    lv: 'pievienot-bankas-kontu',
    en: 'add-bank-account',
    ru: 'dobavit-bankovskiy-schet',
  },
];

export const translatePathForLocale = (pathname: string, locale: string): string => {
  const supportedLocales = ['lv', 'en', 'ru'];
  const pathParts = pathname.split('/').filter(Boolean);

  if (supportedLocales.includes(pathParts[0])) {
    pathParts[0] = locale;
  } else {
    pathParts.unshift(locale);
  }

  const slugIndex = pathParts.length - 1;
  const slug = pathParts[slugIndex];
  const group = localizedSlugGroups.find((entry) => Object.values(entry).includes(slug));

  if (group?.[locale]) {
    pathParts[slugIndex] = group[locale];
  }

  return `/${pathParts.join('/')}`;
};

export const navigateToContact = (): void => {
  const contactPath = getLocalizedPath('/contact');
  window.location.href = contactPath;
};

export const navigateToLoanTypes = (): void => {
  const loanTypesPath = getLocalizedPath('/loan-types');
  window.location.href = loanTypesPath;
};

export const navigateToLoanType = (loanTypeSlug: string): void => {
  const loanTypePath = getLocalizedPath(`/${loanTypeSlug}`);
  window.location.href = loanTypePath;
};

export const getLoanTypeUrl = (loanTypeSlug: string): string => {
  return getLocalizedPath(`/${loanTypeSlug}`);
};

export const getLoanTypeHashUrl = (loanTypeSlug: string): string => {
  const loanTypesPath = getLocalizedPath('/loan-types');
  return `${loanTypesPath}#${loanTypeSlug}`;
};
